import { useEffect, useState } from 'react';
import cn from 'classnames';

import ICON_MINUS from 'assets/slickpay-splash/icon-minus.svg';
import ICON_MINUS_WHITE from 'assets/slickpay-splash/icon-minus-white.svg';
import ICON_PLUS from 'assets/slickpay-splash/icon-plus.svg';
import ICON_PLUS_GREEN from 'assets/slickpay-splash/icon-plus-circle-green.svg';
import { useTranslation } from 'providers/GILT.provider';

import CN from './FaqItem.module.scss';

const FaqItem = ({ title, description, link, variant, isOpen, isDark, scrollTrigger }) => {
  const [toggle, setToggle] = useState(isOpen);
  const { t } = useTranslation();

  useEffect(() => {
    setToggle(isOpen);
  }, [isOpen, scrollTrigger]);

  const minusIcon = isDark ? ICON_MINUS_WHITE : ICON_MINUS;
  const plusIcon = isDark ? ICON_PLUS_GREEN : ICON_PLUS;

  const componentClasses = cn({
    [CN.container]: true,
    [CN[`${variant}Variant`]]: variant,
    [CN.opened]: toggle,
    [CN.darkItem]: isDark,
  });

  return (
    <div data-bem="FaqItem" onClick={() => setToggle(!toggle)} role="button" tabIndex={0} className={componentClasses}>
      <div className={CN.title}>
        {title}
        <img src={toggle ? minusIcon : plusIcon} alt={t('composite.faqItem.linkTitle')} className={CN.toggleIcon} />
      </div>
      {toggle && (
        <div className={CN.description}>
          <div>{description}</div>

          {link && (
            <div className={CN.linkContainer}>
              <a href={link} target="_blank" rel="noopener noreferrer" className={CN.link}>
                {t('composite.faqItem.linkTitle')}
              </a>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FaqItem;
